export const hseStatus = ["New", "HSE Review", "HSE Confirmed", "Closed"];
export const changesList = [
  "New Projects",
  "Process Changes",
  "Equipment Changes",
  "Chemical Changes",
  "Product Changes",
  "De-Commissioning",
  "Layout Changes",
];

export const GRID_CONFIG = {
  noDataText: "No MOC",
  showBorders: true,
  rowAlternationEnabled: true,
  allowColumnReordering: true,
  allowColumnResizing: true,
  columnResizingMode: "widget",
  columnAutoWidth: true,
  columnChooser: {
    enabled: true,
    allowSearch: true,
    mode: "select",
  },
  editing: {
    mode: "popup",
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    useIcons: true,
    popup: {
      title: "Management Of Change",
      showTitle: true,
      position: {
        my: "center",
        at: "center",
        of: window,
      },
    },
  },

  headerFilter: {
    visible: true,
  },
  sorting: {
    mode: "multiple",
  },
  grouping: {
    contextMenuEnabled: true,
  },
  searchPanel: {
    visible: true,
  },
  filterRow: {
    visible: true,
    applyFilter: "auto",
  },
  export: {
    enabled: true,
    fileName: "MOC",
  },

  onToolbarPreparing: function (e) {
    var dataGrid = e.component;
    var toolbarItems = e.toolbarOptions.items;
    // Adds a new item
    toolbarItems.unshift({
      location: "after",
      widget: "dxButton",
      options: {
        icon: "refresh",
        hint: "Refresh",
        onClick: function () {
          dataGrid.refresh();
        },
      },
    });
  },
};

export const GRID_COL_DEF = JSON.stringify([
  "mocid",
  "existingMOCID",
  "changes",
  "description",
  "comments",
  "dueDate",
  "initiator",
  "status",
  "lsImageName",
  "imageName",
]);
